import React, {useState} from "react";
import './index.scss'
import Service from '../../service'
import {Button} from "antd-mobile";

const SyntheticConfirmModal = ({ onClose, successCallBack, clientId }) => {
  const [success, setSuccess] = useState(false)
  const [count, setCount] = useState(0)
  const [date, setDate] = useState()
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    try {
      setLoading(true)
      const res = await Service.fragmentsCompoundService(
        {
          clientId: clientId,
        },
        true
      )
      if(res?.data) {
        setLoading(false)
        setDate(res.data)
        setCount(res?.data?.count)
        setSuccess(true)
      }
    } catch (e) {
      console.log(e);
      setLoading(false)
    }
  }
  const handleKnow = () => {
    onClose()
    successCallBack && successCallBack()
  }
  return (
    <div className="synthetic-confirm-modal">
      <div className="synthetic-confirm-container">
        {!success && (
          <div className="synthetic-confirm">
            <div className="synthetic-confirm-title">确认合成</div>
            <div className="synthetic-confirm-msg">确认将当前碎片合成未藏品？合成后对应碎片将消失</div>
            <div className="synthetic-confirm-btn-box">
              <div className="synthetic-btnFlex">
                <button className="synthetic-cancelBtn" onClick={onClose}>关闭</button>
              </div>
              <div className="synthetic-divider"/>
              <div className="synthetic-btnFlex">
                <Button fill={"none"} loading={loading} className="synthetic-confirmBtn" onClick={handleConfirm}>确认</Button>
              </div>
            </div>
          </div>
        )}
        {success && <div className="synthetic-success">
          <div className="synthetic-success-title">合成成功</div>
          <img className="synthetic-success-img" src={date?.nftImage || require('../../imgs/lion.png')} alt="" />
          {count > 1 && <div className="synthetic-success-count">x{count}</div>}
          <button className="synthetic-success-btn" onClick={handleKnow}>我知道了</button>
        </div>}
      </div>
    </div>
  )
}
export default SyntheticConfirmModal